import { useLocation } from "react-router-dom";
import { routes } from "~/constants";

interface ConfigByRoute {
  [key: string]: {
    hasHeader: boolean;
    hasFooter: boolean;
  };
}

const configByRoute: ConfigByRoute = {
  [routes.setPassword]: {
    hasHeader: false,
    hasFooter: false,
  },
};

interface UseLayoutConfig {
  hasHeader: boolean;
  hasFooter: boolean;
}

export const useLayoutConfig = (): UseLayoutConfig => {
  const location = useLocation();
  const config = configByRoute[location.pathname];

  return {
    hasHeader: config?.hasHeader ?? true,
    hasFooter: config?.hasFooter ?? true,
  };
};
